// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sunzi__clip-yj1pL {
  width: 100%;
  height: 100%;
  position: relative;
}
.sunzi__clip-content-gD6VN {
  background: linear-gradient(#1c1c1c 0%, #111 50%);
  position: relative;
}
.sunzi__clip-content-gD6VN canvas {
  width: 100%;
}
.sunzi__clip-footer-thJCu {
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 12px;
}
.sunzi__clip-footer-thJCu .sunzi__icon-wrapper-j7ymf {
  width: 60px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0;
  margin: 0 19px;
}
.sunzi__clip-footer-thJCu .sunzi__icon-wrapper-j7ymf svg {
  fill: #000;
}
.sunzi__clip-footer-thJCu .sunzi__icon-wrapper-j7ymf.sunzi__icon-wrapper-active-i_q7v svg {
  fill: var(--sunzi-theme-color) !important;
}
.sunzi__clip-footer-thJCu .sunzi__icon-wrapper-j7ymf.sunzi__icon-wrapper-active-i_q7v span {
  color: var(--sunzi-theme-color);
}
.sunzi__clip-footer-thJCu .sunzi__icon-wrapper-j7ymf.sunzi__icon-wrapper-disabled-DiXgE svg {
  fill: #d0d0d0 !important;
}
.sunzi__clip-footer-thJCu .sunzi__icon-wrapper-j7ymf.sunzi__icon-wrapper-disabled-DiXgE span {
  opacity: 0.3;
}
.sunzi__clip-light-izgCf .sunzi__clip-content-gD6VN {
  background: #d8d8d8;
}
.sunzi__clip-light-izgCf .sunzi__clip-footer-thJCu {
  background: #fff;
}
.sunzi__clip-light-izgCf .sunzi__clip-footer-thJCu .sunzi__icon-wrapper-j7ymf svg {
  fill: #000;
}
.sunzi__clip-light-izgCf .sunzi__clip-footer-thJCu .sunzi__icon-wrapper-j7ymf span {
  font-size: 12px;
}
.sunzi__clip-light-izgCf .sunzi__clip-footer-thJCu .sunzi__gusture-HUVKY {
  background: rgba(0, 0, 0, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Clip/style.module.less"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AACF;AAAE;EACE,iDAAA;EACA,kBAAA;AAEJ;AAJE;EAII,WAAA;AAGN;AAAE;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;AAEJ;AARE;EAQI,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,UAAA;EACA,cAAA;AAGN;AAlBE;EAiBM,UAAA;AAIR;AAFM;EAEI,yCAAA;AAGV;AALM;EAKI,+BAAA;AAGV;AAAM;EAEI,wBAAA;AACV;AAHM;EAKI,YAAA;AACV;AAMA;EAEI,mBAAA;AALJ;AAGA;EAKI,gBAAA;AALJ;AAAA;EAQQ,UAAA;AALR;AAHA;EAWQ,eAAA;AALR;AANA;EAeM,8BAAA;AANN","sourcesContent":[".clip {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  &-content {\n    background: linear-gradient(#1c1c1c 0%, #111 50%);\n    position: relative;\n    canvas {\n      width: 100%;\n    }\n  }\n  &-footer {\n    background: #fff;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n    padding: 12px;\n    .icon-wrapper {\n      width: 60px;\n      height: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      flex-direction: column;\n      padding: 0;\n      margin: 0 19px;\n      svg {\n        fill: #000;\n      }\n      &.icon-wrapper-active {\n        svg {\n          fill: var(--sunzi-theme-color) !important;\n        }\n        span {\n          color: var(--sunzi-theme-color);\n        }\n      }\n      &.icon-wrapper-disabled {\n        svg {\n          fill: #d0d0d0 !important;\n        }\n        span {\n          opacity: 0.3;\n        }\n      }\n    }\n  }\n}\n\n.clip-light {\n  .clip-content {\n    background: #d8d8d8;\n  }\n  .clip-footer {\n    background: #fff;\n    .icon-wrapper {\n      svg {\n        fill: #000;\n      }\n      span {\n        font-size: 12px;\n      }\n    }\n    .gusture {\n      background: rgba(0, 0, 0, 0.1);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"clip": `sunzi__clip-yj1pL`,
	"clip-content": `sunzi__clip-content-gD6VN`,
	"clipContent": `sunzi__clip-content-gD6VN`,
	"clip-footer": `sunzi__clip-footer-thJCu`,
	"clipFooter": `sunzi__clip-footer-thJCu`,
	"icon-wrapper": `sunzi__icon-wrapper-j7ymf`,
	"iconWrapper": `sunzi__icon-wrapper-j7ymf`,
	"icon-wrapper-active": `sunzi__icon-wrapper-active-i_q7v`,
	"iconWrapperActive": `sunzi__icon-wrapper-active-i_q7v`,
	"icon-wrapper-disabled": `sunzi__icon-wrapper-disabled-DiXgE`,
	"iconWrapperDisabled": `sunzi__icon-wrapper-disabled-DiXgE`,
	"clip-light": `sunzi__clip-light-izgCf`,
	"clipLight": `sunzi__clip-light-izgCf`,
	"gusture": `sunzi__gusture-HUVKY`
};
export default ___CSS_LOADER_EXPORT___;
